import {
  SUBMIT_RECEIPTS,
  SUBMIT_RECEIPTS_SUCCESS,
  SUBMIT_RECEIPTS_ERROR,
  RESET_SUBMIT_RECEIPTS_SUCCESS,
  GET_BILLING_DETAILS,
  GET_BILLING_DETAILS_SUCCESS,
  RESEND_BILLING_DETAIL_EMAIL,
  RESEND_BILLING_DETAIL_EMAIL_SUCCESS,
  RESEND_BILLING_DETAIL_EMAIL_FAILURE,
} from '../constants/ActionsTypes'

const initialState = {
  billingDetails: [],
  isLoadingSubmitReceipts: false,
  submitReceiptsSuccess: false,
  isLoading: false,
  success: false,
  resendingEmailId: null,
}

function rootReducer(state = initialState, action) {
  let newState

  switch (action.type) {
    case SUBMIT_RECEIPTS:
      newState = { ...state, isLoadingSubmitReceipts: true, submitReceiptsSuccess: false }
      break
    case SUBMIT_RECEIPTS_SUCCESS:
      newState = { ...state, isLoadingSubmitReceipts: false, submitReceiptsSuccess: true }
      break
    case SUBMIT_RECEIPTS_ERROR:
      newState = { ...state, isLoadingSubmitReceipts: false }
      break
    case RESET_SUBMIT_RECEIPTS_SUCCESS:
      return {
        ...state,
        submitReceiptsSuccess: false,
      }
    case GET_BILLING_DETAILS:
      return { ...state, billingDetails: [], isLoading: true, success: false }
    case GET_BILLING_DETAILS_SUCCESS:
      return { ...state, billingDetails: action.payload.data, isLoading: false, success: true }
    case RESEND_BILLING_DETAIL_EMAIL:
      return { ...state, resendingEmailId: action.payload }
    case RESEND_BILLING_DETAIL_EMAIL_SUCCESS:
      return { ...state, resendingEmailId: null }
    case RESEND_BILLING_DETAIL_EMAIL_FAILURE:
      return { ...state, resendingEmailId: null }
    default:
      newState = state
  }
  return newState
}

export default rootReducer
